import { getRequestFormSections } from "@RequestFormV2/constants";
import type { RequestFormMode } from "@RequestFormV2/context/requestFormMode";
import { getSectionKeyForFieldPath } from "@RequestFormV2/utils/getSectionKeyForFieldPath";

function collectApiErrorPaths(data: unknown, prefix = ""): string[] {
  if (!data || typeof data !== "object") return [];

  if (Array.isArray(data)) {
    return data.flatMap((item, index) => collectApiErrorPaths(item, prefix ? `${prefix}.${index}` : String(index)));
  }

  return Object.entries(data as Record<string, unknown>).flatMap(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;

    if (typeof value === "string" || (Array.isArray(value) && value.length > 0)) {
      return [path];
    }

    return collectApiErrorPaths(value, path);
  });
}

export function buildErroredSectionsFromApiError(error: unknown, mode: RequestFormMode = "quote"): string[] {
  const data = (error as { response?: { data?: unknown } })?.response?.data;
  if (!data || typeof data !== "object") return [];

  const sectionKeys = new Set<string>();
  collectApiErrorPaths(data).forEach((path) => {
    const section = getSectionKeyForFieldPath(path, mode);
    if (section) sectionKeys.add(section);
  });

  return getRequestFormSections(mode)
    .map(({ key }) => key)
    .filter((key) => sectionKeys.has(key));
}
